import React, { createContext, useContext } from 'react'

const EMPTY_ANALYTICS_VALUE = {}
const AnalyticsContext = createContext(EMPTY_ANALYTICS_VALUE)

export const AnalyticsProvider = ({ value, children }) => (
  <AnalyticsContext.Provider value={value || EMPTY_ANALYTICS_VALUE}>{children}</AnalyticsContext.Provider>
)

export const useAnalyticsContext = () => useContext(AnalyticsContext)
